import * as GLOBAL from "../data/global.js";

export default class RelaisServices {

    static getRelais() {
        return fetch(`${global.SERVER_ADDRESS}/relais`)
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static addRelais(relais) {
        return fetch(`${global.SERVER_ADDRESS}/relais`, {
            method: 'POST',
            body: JSON.stringify(relais),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateRelais(relais) {
        return fetch(`${global.SERVER_ADDRESS}/relais/${relais.slug}`, {
            method: 'PUT',
            body: JSON.stringify(relais),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static deleteRelais(relais) {
        return fetch(`${global.SERVER_ADDRESS}/relais/${relais.slug}`, {
            method: 'DELETE',
            body: JSON.stringify(relais),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static handleError(error) {
        console.log(error);
    }


}